/* eslint-disable default-param-last */
import {
  CERT_DETAILS_COL_PICKER_LOADING,
  CERT_DETAILS_LISTS_ERROR,
  SET_CERT_DETAILS_CERT_KEY,
  SET_CERT_DETAILS_COLUMN_PICKER_LIST,
  SET_CERT_DETAILS_FLATTENED_COLUMN_PICKER_LIST,
  SET_CERT_DETAILS_VIEW_CAMPAIGN_KEY,
  SET_CERT_DETAILS_VIEW_CERT_AUDITOR,
  SET_CERT_DETAILS_VIEW_CERT_NAME,
  SET_CERT_DETAILS_VIEW_ROWS_LIST,
  SET_CERT_GLOBAL_DATE_FORMAT,
  SET_CERT_OBJECT_FOR_REDIRECT,
  SET_CERTS_TIME_ZONE,
  SET_TOUCH_DEVICE_STATUS,
  UPDATE_SCREEN_SIZE,
} from '../types';

const INITIAL_STATE = {
  mediaQueryValue: 0,
  isTouchEnabled: false,
  certKey: null,
  timeZone: '',
  globalDateFormat: 'MMM dd, yyyy',
  backNavigation: {},
  campaignKey: null,
  isAuditor: true,
  certificationName: null,
  isColPickerApiLoading: false,
  columnPickerList: null,
  columnLabelKeys: null,
  viewRowsList: null,
  isGlobalError: false,
  globalError: null,
};

const globalReducer = (state = INITIAL_STATE, action) => {
  switch (action?.type) {
    case UPDATE_SCREEN_SIZE:
      return {
        ...state,
        mediaQueryValue: action?.payload,
      };

    case SET_TOUCH_DEVICE_STATUS:
      return {
        ...state,
        isTouchEnabled: action?.payload,
      };

    case SET_CERT_GLOBAL_DATE_FORMAT:
      return {
        ...state,
        globalDateFormat: action?.payload,
      };

    case SET_CERTS_TIME_ZONE:
      return {
        ...state,
        timeZone: action?.payload,
      };

    case SET_CERT_DETAILS_CERT_KEY:
      return {
        ...state,
        certKey: action?.payload,
      };

    case SET_CERT_OBJECT_FOR_REDIRECT:
      return {
        ...state,
        backNavigation: action?.payload,
      };

    case SET_CERT_DETAILS_VIEW_CAMPAIGN_KEY:
      return {
        ...state,
        campaignKey: action?.payload,
      };

    case SET_CERT_DETAILS_VIEW_CERT_AUDITOR:
      return {
        ...state,
        isAuditor: action?.payload,
      };

    case SET_CERT_DETAILS_VIEW_CERT_NAME:
      return {
        ...state,
        certificationName: action?.payload,
      };

    case CERT_DETAILS_COL_PICKER_LOADING:
      return {
        ...state,
        isColPickerApiLoading: action?.payload,
      };

    case CERT_DETAILS_LISTS_ERROR:
      return {
        ...state,
        isGlobalError: action?.payload?.isError,
        globalError: action?.payload?.error,
      };

    case SET_CERT_DETAILS_COLUMN_PICKER_LIST:
      return {
        ...state,
        columnPickerList: action?.payload,
      };

    case SET_CERT_DETAILS_FLATTENED_COLUMN_PICKER_LIST:
      return {
        ...state,
        columnLabelKeys: action?.payload,
      };

    case SET_CERT_DETAILS_VIEW_ROWS_LIST:
      return {
        ...state,
        viewRowsList: action?.payload,
      };

    default:
      return state;
  }
};

export default globalReducer;
